import React, { useEffect, useState } from 'react';
import {
    DATA_CONFIGURATION,
    DEFAULT_VALUE,
    ENTER,
    INCREMENT,
    LABEL,
    REQUIRED
} from '../ISRConstants';
import {
    TConnector,
    TField,
    TFieldDataConfiguration, TIndexState,
    TProductCategory,
    TSubmodel,
    TUpsertISRProjectDataModelsInput
} from '../Pages/DefineModel/model';
import ToggleButton from 'Components/Common/components/Inputs/ToggleButton';
import { useISRContext } from '../Hooks/useISRContext';
import { getAllProjectClass } from '../Pages/DefineModel/ModelServices/ModalServices';
import { toast } from 'react-toastify';
import ConfigurationFilterComponent from './ConfigurationFilterComponent';

type RangeConfigurationProps = {
    id: string;
    selectedItem: TField | TSubmodel | TProductCategory | TConnector | null;
    updateFieldDataConfiguration: (updatedConfig: TFieldDataConfiguration) => void;
    projectId?: string | null | undefined;
    userProjectDataModels: TUpsertISRProjectDataModelsInput;
    indexInfo: TIndexState;
}

const RangeConfiguration = ({id, selectedItem, updateFieldDataConfiguration, projectId, userProjectDataModels, indexInfo}: RangeConfigurationProps) => {
    const [fieldDataConfiguration, setFieldDataConfiguration] = useState<TFieldDataConfiguration>({});
    const isrContext = useISRContext();

    useEffect(() => {
        const existingValue = selectedItem && 'dataConfiguration' in selectedItem && selectedItem?.dataConfiguration ? selectedItem.dataConfiguration : {}
        setFieldDataConfiguration(existingValue);
    }, [selectedItem]);

    useEffect(() => {
        const hasChanges = Object.keys(fieldDataConfiguration).some(
            (key) => fieldDataConfiguration[key as keyof TFieldDataConfiguration] !== undefined
        );
        if (hasChanges) {
            updateFieldDataConfiguration(fieldDataConfiguration);
        }
    }, [fieldDataConfiguration]);

    const handleIncrementChange = (value: number) => {
        setFieldDataConfiguration((prevConfig) => ({...prevConfig, increment: value}));
    };

    const handleLabelChange = (value: string) => {
        setFieldDataConfiguration((prevConfig) => ({...prevConfig, label: value}));
    };

    const handleDefaultValueChange = (value: string) => {
        setFieldDataConfiguration((prevConfig) => ({...prevConfig, defaultValue: value.length > 0 ? Number(value): value}));
    };

    const handleRequiredChange = (value: boolean) => {
        setFieldDataConfiguration((prevConfig) => ({...prevConfig, fieldRequired: value}));
    }

    // const handleAnalyticChange = (value: boolean) => {
    //     setFieldDataConfiguration((prevConfig) => ({...prevConfig, enableAnalytic: value}));
    // }

    useEffect(() => {
        fetchAllClasses();
    }, []);

    const fetchAllClasses = async () => {
        try {
            const responseData = await getAllProjectClass(projectId ?? '');
            if (responseData?.done) {
                isrContext?.setFieldClasses(responseData?.data?.fieldClasses ?? []);
                isrContext?.setModelClasses(responseData?.data?.modelClasses ?? []);
            } else {
                toast.error(responseData?.message);
            }
        } catch (error) {
            console.log('Error', error);
        }
    }

    return (
        <React.Fragment>
            <div id={id} className='cart-style-dm'>
                <label id={`${id}-title`} className='cart-title'>{DATA_CONFIGURATION}</label>
                <div id={`${id}-settings-section`} className='tw-flex tw-items-center tw-mt-3'>
                    <div id={`${id}-increment-container`} className='tw-w-[15%]'>
                        <label id={`${id}-increment-label`} className='tw-text-sm tw-text-[#747593] tw-block'>{INCREMENT}</label>
                        <input 
                            id={`${id}-increment-input`}
                            className="input-field-dm" 
                            placeholder={ENTER}
                            type='number'
                            onChange={(e) => handleIncrementChange(Number(e.target.value))}
                            value={fieldDataConfiguration?.increment ?? ''}
                        />
                    </div>
                    <div id={`${id}-label-container`} className='tw-w-[30%] tw-ms-5'>
                        <label id={`${id}-label-text`} className='tw-text-sm tw-text-[#747593] tw-block'>{LABEL}</label>
                        <input 
                            id={`${id}-label-input`}
                            className="input-field-dm" 
                            placeholder={ENTER}
                            type='text'
                            onChange={(e) => handleLabelChange(e.target.value)}
                            value={fieldDataConfiguration?.label ?? ''}
                        />
                    </div>
                    <div id={`${id}-default-value-container`} className='tw-w-[15%] tw-ms-5'>
                        <label id={`${id}-default-value-label`} className='tw-text-sm tw-text-[#747593] tw-block'>{DEFAULT_VALUE}</label>
                        <input 
                            id={`${id}-default-value-input`}
                            className="input-field-dm" 
                            placeholder={ENTER}
                            type='number'
                            onChange={(e) => handleDefaultValueChange(e.target.value)}
                            value={fieldDataConfiguration?.defaultValue ?? ''}
                        />
                    </div>
                    <div id={`${id}-required-container`} className='tw-w-[10%] tw-ms-5'>
                        <label id={`${id}-required-label`} className='tw-text-sm tw-text-[#747593] tw-block tw-mb-2'>{REQUIRED}</label>
                        <ToggleButton
                            id={`${id}-required-toggle`}
                            name="Required" 
                            value={fieldDataConfiguration?.fieldRequired ?? false} 
                            onChange={(e) => handleRequiredChange(e.target.checked)} 
                        />
                    </div>
                </div>

                <ConfigurationFilterComponent 
                    id={`${id}-config-filter`}
                    fieldDataConfiguration={fieldDataConfiguration} 
                    setFieldDataConfiguration={setFieldDataConfiguration} 
                    userProjectDataModels={userProjectDataModels} 
                    indexInfo={indexInfo}
                    isRangeField={true}
                />

            </div>
        </React.Fragment>
    );
}

export default RangeConfiguration;